<p>compass-payment-confirmed works!</p>
